// packages/web-ui/src/panels/file-viewer/FileViewerSkeleton.tsx
//
// Story W3-S2 AC #1.3 / AC #12.2 — loading-state placeholder. Renders a
// 40 px header shell, a pulsing body, and a 24 px status-bar shell.

import type { JSX } from 'react';

export function FileViewerSkeleton(): JSX.Element {
  return (
    <div
      data-testid="file-viewer-skeleton"
      className="flex h-full w-full flex-col"
    >
      <div
        data-testid="file-viewer-skeleton-header"
        className="flex h-10 items-center border-b border-[var(--color-taupe-300)] px-3"
        style={{ backgroundColor: 'var(--color-cream-100)' }}
      >
        <div className="h-3 w-32 animate-pulse rounded bg-[var(--color-taupe-300)]" />
      </div>
      <div
        className="flex-1 animate-pulse"
        style={{ backgroundColor: 'var(--color-cream-50)' }}
        aria-label="Loading editor…"
      >
        <div className="flex h-full items-center justify-center text-sm text-[var(--color-taupe-700)]">
          Loading editor…
        </div>
      </div>
      <div
        data-testid="file-viewer-skeleton-statusbar"
        className="flex h-6 items-center border-t border-[var(--color-taupe-300)] px-3"
        style={{ backgroundColor: 'var(--color-cream-100)' }}
      >
        <div className="h-2 w-24 animate-pulse rounded bg-[var(--color-taupe-300)]" />
      </div>
    </div>
  );
}
